import {
  CLEAR_STORE,
  HIDE_COMMON_MESSAGE,
  SHOW_COMMON_MESSAGE,
  SET_REDIRECT_URL
} from '../../action-contants';

const INITIAL_STATE = {
  message: {
    text: [],
    type: '',
    hide: false,
    redirectURL: null
  }
};

export default function messageReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    case SHOW_COMMON_MESSAGE:
      return { ...state, message: action.data, hide: false };
    case HIDE_COMMON_MESSAGE:
      return { ...state, hide: true };
    case SET_REDIRECT_URL:
      return { ...state, redirectURL: action.data };
    default:
      return state;
  }
}
